import { render } from "./UserTools.vue?vue&type=template&id=2d8ae5e0&scoped=true"
import script from "./UserTools.vue?vue&type=script&lang=js"
export * from "./UserTools.vue?vue&type=script&lang=js"

import "./UserTools.vue?vue&type=style&index=0&id=2d8ae5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ae5e0"]])

export default __exports__